import React from 'react';
function OrderedList({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 5h10M4 17h2M6 21v-4M4 3h1M5 7V3M4 19h2M4 21h2M4 10h2M4 12h2M4 12v2M6 10v2M4 14h2M10 12h10M10 19h10"
      />
    </svg>
  );
}

export default OrderedList;
